import React from "react";
import { useTranslation } from "react-i18next";
import { TypeSpecificFieldsProps } from "./types";

const PersonalAccidentFields: React.FC<TypeSpecificFieldsProps> = ({ data, onChange }) => {
  const { t } = useTranslation(['insurance', 'common']);
  const set = (key: string, value: any) => onChange({ ...data, [key]: value });

  return (
    <div className="irf-grid">
      <div className="irf-field">
        <label>{t('insurance:personalAccident.accidentalDeathBenefit')}</label>
        <input
          type="number"
          value={data.accidental_death_benefit ?? ""}
          onChange={(e) => set("accidental_death_benefit", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:personalAccident.accidentalDeathBenefitPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:personalAccident.ptdBenefit')}</label>
        <input
          type="number"
          value={data.ptd_benefit ?? ""}
          onChange={(e) => set("ptd_benefit", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:personalAccident.ptdBenefitPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:personalAccident.ppdBenefit')}</label>
        <input
          type="number"
          value={data.ppd_benefit ?? ""}
          onChange={(e) => set("ppd_benefit", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:personalAccident.ppdBenefitPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:personalAccident.ttdWeeklyAllowance')}</label>
        <input
          type="number"
          value={data.ttd_weekly_allowance ?? ""}
          onChange={(e) => set("ttd_weekly_allowance", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:personalAccident.ttdWeeklyAllowancePlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:personalAccident.ttdMaxWeeks')}</label>
        <input
          type="number"
          value={data.ttd_max_weeks ?? ""}
          onChange={(e) => set("ttd_max_weeks", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:personalAccident.ttdMaxWeeksPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:personalAccident.coverageScope')}</label>
        <input
          value={data.coverage_scope || ""}
          onChange={(e) => set("coverage_scope", e.target.value)}
          placeholder={t('insurance:personalAccident.coverageScopePlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:personalAccident.occupationClass')}</label>
        <input
          value={data.occupation_class || ""}
          onChange={(e) => set("occupation_class", e.target.value)}
          placeholder={t('insurance:personalAccident.occupationClassPlaceholder')}
        />
      </div>
    </div>
  );
};

export default PersonalAccidentFields;
